(function() {
'use strict';

angular
    .module('TR')
    .controller('FlightCapture', FlightCapture);

function FlightCapture(bookingService,
                       $routeParams,
                       tripService,
                       $scope,
                       resourceService) {
    const cm = this;
    let dir;
    let inverse;

    cm.setDepartureAirport = setDepartureAirport;
    cm.setDestinationAirport = setDestinationAirport;
    cm.setDateAndTime = setDateAndTime;
    cm.resetDestinationAirport = resetDestinationAirport;

    tripService.getTransferDestinationAirport($routeParams.tripId).then(airport => cm.destinationAirport = airport);

    function _setAirport(start, end, item, booking) {
        booking.UserData.ConnectingFlight = booking.UserData.ConnectingFlight || {};
        booking.UserData.ConnectingFlight[`${dir + start}Airport`] = item.Code;
        booking.UserData.ConnectingFlight[`${dir + start}AirportName`] = item.Title;

        if (booking.UserData.ConnectingFlight[`${inverse + end}Airport`] == null || booking.UserData.ConnectingFlight[`${inverse + end}Airport`] === '') {
            booking.UserData.ConnectingFlight[`${inverse + end}Airport`] = item.Code;
            booking.UserData.ConnectingFlight[`${inverse + end}AirportName`] = item.Title;
        }

        bookingService.updateBooking(booking);
    }

    function _resetAirport(start, booking) {
        booking.UserData.ConnectingFlight[`${dir + start}Airport`] = null;
        booking.UserData.ConnectingFlight[`${dir + start}AirportName`] = null;
    }

    function _setDirection(outbound) {
        dir = outbound === true ? 'Outbound' : 'Inbound';
        inverse = dir === 'Outbound' ? 'Inbound' : 'Outbound';
    }

    function setDepartureAirport(item, outbound, booking) {
        if (_isValidDepartureAirport(item)) {
            _setDirection(outbound);
            _setAirport('Departure', 'Destination', item, booking);
            $scope.$broadcast('flash:hide');
        } else {
            _setAirport('Departure', 'Destination', {}, booking);
            $scope.$broadcast('flash:error', resourceService.get('DEPARTUREAIRPORTERROR'));
        }
    }

    function _isValidDepartureAirport(airport) {
        return !cm.destinationAirport || airport && airport.Code && airport.Code !== cm.destinationAirport.Code;
    }

    function setDestinationAirport(item, outbound, booking) {
        _setDirection(outbound);
        _setAirport('Destination', 'Departure', item, booking);
    }

    function setDateAndTime(date, booking, outbound) {
        _setDirection(outbound);
            booking.UserData.ConnectingFlight[`${dir}Date`] = cm.isStartTimeApprovedByCustomer ? date : null;
            bookingService.updateBooking(booking);
    }

    function resetDestinationAirport(outbound, booking) {
        _setDirection(outbound);
        _resetAirport('Destination', booking);
    }
}
})();
